import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Nullable } from '../../../shared/types';
import { Utilisateur } from '../../models/utilisateur';
import { UtilisateurService } from '../../services/utilisateur.service';

@Component({
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit {
  private _currentUser!: Partial<Nullable<Utilisateur>>;
  private _canEdit!: Utilisateur.CanEdit;
  private _isCurrentUserIdNot!: boolean;

  get currentUser(): Partial<Nullable<Utilisateur>> {
    return this._currentUser;
  }

  get canEdit(): Utilisateur.CanEdit {
    return this._canEdit;
  }

  get isCurrentUserIdNot(): boolean {
    return this._isCurrentUserIdNot;
  }

  constructor(
    private readonly utilisateurService: UtilisateurService,
    private readonly titleService: Title,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    await this.loadCurrentUser();
    this.setEditPermissions();
    this.titleService.setTitle(`Perval | Mon profil`);
  }

  async loadCurrentUser(): Promise<void> {
    this._currentUser = await this.utilisateurService.getCurrentUtilisateur();
  }

  private setEditPermissions(): void {
    if (!this._currentUser) {
      return;
    }

    this._isCurrentUserIdNot = this.utilisateurService.isUserIdNot(
      this._currentUser as Utilisateur,
    );

    this._canEdit = {
      nom: !this._isCurrentUserIdNot,
      prenom: !this._isCurrentUserIdNot,
      email: !this._isCurrentUserIdNot || !this._currentUser.isExternalEmail,
      phone: true,
    };
  }
}
